import { Typography } from '@mui/material'
import { useTranslation } from 'react-i18next'

const PrequalNotCompleted = () => {
  const { t } = useTranslation()
  return <Typography variant="body1">{t('viewCreditApplication.prequalNotCompleted')}</Typography>
}

export default PrequalNotCompleted
